import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AllRoutes } from 'constants/routes';
import { useTableOffset } from 'hooks/useTableOffset';
import { useEntitiesTable } from 'hooks/useEntitiesTable';
import { actions } from 'core/redux/api/veta/tep/notifications';
import { clientsNotificationsPageSelector } from 'core/redux/selectors/tep';
import { useClientsNotificationsColumns } from './useClientsNotificationsColumns';

export const useClientsNotifications = () => {
  const dispatch = useDispatch();

  const {
    page,
    pageSize,
    sort,
    search,
    searchParams,
    columnsSorting,
    updatePage,
    updatePageSize,
    sortColumnData,
    searchHandler,
  } = useEntitiesTable(AllRoutes.TepClientNotifications);

  const { isLoading, total, notifications } = useSelector(clientsNotificationsPageSelector);

  const { offset } = useTableOffset();

  const columns = useClientsNotificationsColumns();

  const pageData = { no: page, size: pageSize.value, sort, search: search || undefined };

  const fetchNotifications = () => {
    dispatch(actions.loadClientsNotifications.request({ payload: pageData }));
  };

  const controlProps = { search, searchHandler };

  const tableProps = {
    isLoading,
    offset,
    data: notifications || [],
    columns,
    columnsSorting,
    sortColumnData,
  };

  const footerProps = {
    totalCount: total || 0,
    pageSize,
    page,
    onPageChange: updatePage,
    updatePageSize,
  };

  useEffect(() => {
    fetchNotifications();
  }, [searchParams]);

  useEffect(() => {
    if (notifications?.length === 0 && page !== 1) {
      updatePage({ selected: page - 1 });
    }
  }, [notifications]);

  return { controlProps, tableProps, footerProps };
};
